export const routes = {
  app: "/app",
  login: "/app/login",
  kb: "/app/kb",
  intakes: "/app/intakes",
  intakeDetail: (id: string) => `/app/intakes/${id}`,
  kbArticle: (slug: string) => `/app/kb/${slug}`,
  kbEdit: (slug: string) => `/app/kb/${slug}/edit`,
  kbNew: "/app/kb/new",
} as const;